var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnswerButtonBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.431641,
    y: 0.0922852,
    width: 119.121,
    height: 119.121,
    rx: 13.4012,
    fill: "url(#paint0_linear_319_31390)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.501 107.616V12.3187L116.523 10.6436L110.567 89.0031C109.823 93.0048 109.599 99.1284 102.005 105.382C95.8958 110.414 39.6212 113.487 11.6406 116.178L12.8505 119.342C40.7075 119.28 98.4317 119.193 106.472 119.342C114.513 119.491 118.85 112.176 119.501 107.616Z",
    fill: "#EBE0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_31390",
    x1: 16.5142,
    y1: 9.60915,
    x2: 101.601,
    y2: 127.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6FFF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerButtonBackground);
export default __webpack_public_path__ + "static/media/AnswerButtonBackground.5aecb05528f2ef930ff2.svg";
export { ForwardRef as ReactComponent };